import 'babel-polyfill'
//==========================================================
import Vue from 'vue';
import { router } from './router/router'
import VeeValidate, { Validator } from 'vee-validate'
import VueResource from 'vue-resource'
import App from './App.vue';
import fa from 'vee-validate/dist/locale/fa';
import * as VueGoogleMaps from "vue2-google-maps";
import VueNumeric from 'vue-numeric';
//==========================================================
import { store } from './store/store'
import { registerGlobalComponents } from './global-components';
import { registerGlobalFilters } from "./global-filters";

//==========================================================
Vue.use(VueResource);
Vue.use(VueNumeric);
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
Vue.use(VuePersianDatetimePicker, {
    name: 'custom-date-picker',
    props: {
        format: 'jYYYY/jMM/jDD',
        displayFormat: 'jYYYY/jMM/jDD',
        editable: false,
        inputClass: 'form-control my-custom-class-name',
        placeholder: 'تاریخ را وارد کنید ... ',
        altFormat: 'YYYY/MM/DD',
        color: '#00acc1',
        autoSubmit: true,
        //...  
        //... And whatever you want to set as default.
        //... 
    }
});
Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyB6w_TqF8RRH_zTOZFUzUZux1EVQ0LN7fU",
        libraries: "places" // necessary for places input
    }
});
Vue.use(VeeValidate, {
    classes: true,
    classNames: {
        valid: 'is-valid',
        invalid: 'is-invalid'
    }
});
Validator.localize('fa', fa);
//==========================================================
registerGlobalComponents();
registerGlobalFilters();
//==========================================================
new Vue({
    router: router ,
    store,
    render: h => h(App),
   
}).$mount('#app');
//==========================================================
